import styled from 'styled-components';
import { colors } from '../../../../theme/style-helpers';

export const Container = styled.div`
  margin-top: 24px;
`;

export const Title = styled.h3`
  font-size: 16px;
  font-weight: 700;
  color: ${colors.BLACK};
  margin-bottom: 16px;
`;

export const ScrollBox = styled.div`
  border: 1px solid ${colors.COOL_GREY};
  border-radius: 4px;
  padding: 16px;
  max-height: 300px;
  overflow-y: auto;
  background-color: ${colors.WHITE};
  margin-bottom: 16px;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: ${colors.LIGHT_GREY};
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${colors.COOL_GREY};
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${colors.BRAND_ORANGE};
  }
`;

export const TermsContent = styled.div`
  font-size: 14px;
  line-height: 1.6;
  color: ${colors.BLACK};

  h4 {
    font-size: 14px;
    font-weight: 700;
    margin-top: 16px;
    margin-bottom: 8px;
  }

  p {
    margin-bottom: 12px;
  }

  strong {
    font-weight: 700;
  }
`;

export const CheckboxWrapper = styled.div`
  margin-top: 16px;
`;
